package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.DayTemplate
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import kotlinx.coroutines.async
import kotlinx.coroutines.coroutineScope

// domain/usecase/skeleton/GetSkeletonEditorDataUseCase.kt
class GetSkeletonEditorDataUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    // A specific container for this screen's data requirements
    data class EditorData(
        val weekSkeleton: Map<Int, String?>,
        val dayTemplates: List<DayTemplate>,
        val shiftTemplates: List<ShiftTemplate>,
        val availableRoles: List<String>,
        val availableSkills: List<String>
    )

    suspend operator fun invoke(workplaceId: String): Result<EditorData> = runCatching {
        // Business Logic: We need all 3 to edit the skeleton properly
        coroutineScope {
            val workplaceDef = async { workplaceRepository.getWorkplace(workplaceId).getOrThrow() }
            val dayTemplatesDef =
                async { workplaceRepository.getDayTemplates(workplaceId).getOrThrow() }
            val shiftTemplatesDef =
                async { workplaceRepository.getShiftTemplates(workplaceId).getOrThrow() }

            val workplace = workplaceDef.await()

            EditorData(
                weekSkeleton = workplace.settings.defaultWeeklySkeleton,
                dayTemplates = dayTemplatesDef.await(),
                shiftTemplates = shiftTemplatesDef.await(),
                availableRoles = workplace.settings.availableRoles,
                availableSkills = workplace.settings.workplaceSkills
            )
        }
    }
}